import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SaveSlackIntegrationCommandClass;
function SaveSlackIntegrationCommand() {
  if (SaveSlackIntegrationCommandClass === VOID) {
    class $ {
      constructor(partyId, channel, team) {
        this.x2m_1 = partyId;
        this.y2m_1 = channel;
        this.z2m_1 = team;
      }
      a2n(partyId, channel, team) {
        return new (SaveSlackIntegrationCommand())(partyId, channel, team);
      }
      b2n(partyId, channel, team, $super) {
        partyId = partyId === VOID ? this.x2m_1 : partyId;
        channel = channel === VOID ? this.y2m_1 : channel;
        team = team === VOID ? this.z2m_1 : team;
        return $super === VOID ? this.a2n(partyId, channel, team) : $super.a2n.call(this, partyId, channel, team);
      }
      toString() {
        return 'SaveSlackIntegrationCommand(partyId=' + this.x2m_1.toString() + ', channel=' + this.y2m_1 + ', team=' + this.z2m_1 + ')';
      }
      hashCode() {
        var result = this.x2m_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.y2m_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z2m_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveSlackIntegrationCommand()))
          return false;
        if (!this.x2m_1.equals(other.x2m_1))
          return false;
        if (!(this.y2m_1 === other.y2m_1))
          return false;
        if (!(this.z2m_1 === other.z2m_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveSlackIntegrationCommand');
    SaveSlackIntegrationCommandClass = $;
  }
  return SaveSlackIntegrationCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher3kdydho2ojhnk,
  SaveSlackIntegrationCommand as SaveSlackIntegrationCommand3vduj8nfpy1wd,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationCommand.mjs.map
